import { useRef, useState } from 'react';
import SelectOverlay from 'components/Inputs/SelectOverlay';
import MultiSelect from '__components/Inputs/MultiSelect';
import { ApplyMenuButton, ClearMenuButton } from '__components/Kizen/Menu';
import { EMPTY_ARRAY } from 'utility/fieldHelpers';
import { useTranslation } from 'react-i18next';
import { ValidIcons } from '@kizen/kds/Icon';
import { Icon } from '@kizen/kds/Icon';
import { useTooltip } from '__components/Kizen/Tooltip';
import { ICON_BUTTON_DELAY } from 'components/Kizen/Tooltip';
import { DashletFilterCount } from '__pages/Dashboard/components/Dashlet/styles';

export const IconDropdown = ({
  onChange,
  onHide,
  isReadOnly,
  icon,
  isMobile,
  value = [],
  disabled = false,
  options = [],
  isLoading = false,
}: {
  onChange: (val: any) => void;
  onHide?: () => void;
  isReadOnly?: boolean;
  icon: ValidIcons;
  isMobile?: boolean;
  value?: { value: string; label: string }[];
  disabled?: boolean;
  options?: {
    id: string;
    label: string;
    options: { label: string; value: string }[];
  }[];
  isLoading?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);

  const handleHide = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const [innerValue, setInnerValue] = useState(value);
  const handleClickApply = () => {
    onHide?.();
    if (!disabled) {
      onChange?.(innerValue);
    }
  };

  const handleClickClear = () => {
    onHide?.();
    if (!disabled) {
      onChange?.(EMPTY_ARRAY);
    }
  };

  const handleChange = (val: any) => setInnerValue(val);

  const { t } = useTranslation();

  const [tooltipProps, tooltip] = useTooltip(
    {
      label: t('Select Calendars'),
      delay: ICON_BUTTON_DELAY,
    },
    () => !isMobile
  );

  const showValue = value.length > 0;

  return (
    <>
      <div
        className={`relative pt-1 flex items-center text-button-tertiary-default dashlet-control dashlet-calendar-menu ${showValue ? 'dashlet-always-visible' : ''} pb-1 mx-2`}
        ref={triggerRef}
        onClick={handleOpen}
        {...tooltipProps}
      >
        <Icon icon={icon} size="md" tooltipEnabled={false} />
        {tooltip}
        {showValue && (
          <DashletFilterCount scale="0.8" offset="1">
            {value.length}
          </DashletFilterCount>
        )}
      </div>
      <SelectOverlay
        show={isOpen}
        onHide={handleHide}
        target={triggerRef.current}
        iDoNotWantToMountTwice
      >
        <MultiSelect
          onSubmit={handleClickApply}
          handleClickApply={handleClickApply}
          value={innerValue}
          onChange={handleChange}
          isReadOnly={isReadOnly || disabled}
          disabled={isReadOnly || isLoading || disabled}
          menuIsOpen={!isReadOnly}
          menuLeftButton={
            disabled ? null : (
              <ClearMenuButton onClick={handleClickClear}>
                {t('Clear & Close')}
              </ClearMenuButton>
            )
          }
          menuRightButton={
            disabled ? null : <ApplyMenuButton onClick={handleClickApply} />
          }
          options={options}
        />
      </SelectOverlay>
    </>
  );
};
